import { render, staticRenderFns } from "./AgeInput.vue?vue&type=template&id=557dfb55&scoped=true&"
import script from "./AgeInput.vue?vue&type=script&lang=js&"
export * from "./AgeInput.vue?vue&type=script&lang=js&"
import style0 from "./AgeInput.vue?vue&type=style&index=0&id=557dfb55&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557dfb55",
  null
  
)

export default component.exports